import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { UIRouter }                from '@uirouter/core';
import { TranslateService }       from '@ngx-translate/core';

import { ApiService }      from '../api/api.service';
import { SessionService }  from '../sessions/session.service';
import { Table }                 from '../table/types/table';
import { TableQueryParameters } from '../table/types/table-query-parameters';
import { TableRowEvent }        from '../table/types/table-row-event';
import { TableService }    from '../table/table.service';
import { VehicleModel }    from './models/vehicle';
import { EditComponent }   from '../table/cell-components/actions/edit.component';

@Component({
  selector   : 'wor-vehicles-list',
  template: require('./vehicles.list.component.html')
})
export class VehiclesListComponent implements AfterViewInit, OnInit {
  @Input() vehicles: any;
  @Input() actionsFactory: any;

  filtering: any;
  tableSettings: Table;

  private tableCacheKey = 'vehicles';

  constructor (
    private apiService       : ApiService,
    private router           : UIRouter,
    private sessionService   : SessionService,
    private tableService     : TableService,
    private translateService : TranslateService
  ) {}

  ngOnInit () {
    const company        = this.sessionService.company();
    const fleetCodeLabel = company.company_variable_fields?.fleet_code_name || this.translateService.instant('VEHICLE_SPACE.FLEET_CODE');
    const regoLabel      = company.company_variable_fields?.plate_number_name || this.sessionService.countrySettings().rego_label;

    this.filtering = this.tableService.setFiltersFromCache(this.tableCacheKey, {
      archived_only: false,
      value        : ''
    });

    const columns: any[] = [
      {
        classes: 'all-caps',
        header : { text: regoLabel },
        field  : 'plate_number'
      },
      {
        header: { text: this.translateService.instant('VEHICLE_SPACE.MAKE') },
        field : 'make'
      },
      {
        header: { text: this.translateService.instant('VEHICLE_SPACE.MODEL') },
        field : 'model'
      },
      {
        header: { text: this.translateService.instant('JS_SPACE.COLUMNS.CUSTOMER_NAME') },
        field : 'display_name'
      }
    ];

    if (company.company_settings?.show_fleet_code) {
      columns.push({
        field : 'fleet_code',
        header: { text: fleetCodeLabel }
      });
    }

    const actionsFactory = this.actionsFactory || EditComponent;

    columns.push({
      component: {
        bindings: {
          outputs: {
            onEditClick   : event => this.viewVehicle(event),
            onBookingClick: event => this.createBooking(event),
            onInvoiceClick: event => this.createInvoice(event)
          }
        },
        enabled: true,
        factory: actionsFactory
      },
      sortable: false
    });

    this.tableSettings = {
      broadcast: 'filterVehicles',
      cache    : {
        enabled: true,
        key    : this.tableCacheKey
      },
      columns,
      empty: {
        text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_VEHICLES_FOUND')
      },
      pagination: {
        enabled   : true,
        pageSize  : this.tableService.getCachedPaging(this.tableCacheKey).pageSize || 10,
        pageSizes : [ 10, 25, 50 ],
        queryCount: () => this.apiService.get('/filters/count', [
          this.filtering.value || '*',
          'vehicles',
          this.filtering.archived_only
        ])
      },
      rows: {
        highlight: { enabled: true }
      },
      sorting: this.tableService.setSortingFromCache(this.tableCacheKey, {
        direction: 'asc',
        field    : 'plate_number'
      })
    };
  }

  ngAfterViewInit (): void {
    const interval = setInterval(() => {
      if (typeof window['filterVehicles'] === 'function') {

        clearInterval(interval);

        this.onFiltersChanged();

      }
    }, 100);
  }

  createBooking ( vehicle : VehicleModel ) : void {
    this.router.stateService.go('app.event', {
      customer_id: vehicle.customer_id,
      vehicle_id : vehicle.id
    });
  }

  createInvoice ( vehicle : VehicleModel ) : void {
    this.router.stateService.go('app.invoice', {
      customer_id: vehicle.customer_id,
      vehicle_id : vehicle.id
    });
  }

  getVehicles ( params : TableQueryParameters ) : Promise<any> {
    return this.apiService.stream('/filters', [
      this.filtering.value || '*',
      'vehicles',
      params.offset,
      params.pageSize,
      params.field,
      params.direction,
      this.filtering.archived_only
    ]).then(vehicles => {
      this.vehicles = vehicles;

      return vehicles;
    });
  }

  onFiltersChanged () : void {


    window['filterVehicles'](this.filtering);


  }

  onRowDoubleClick ( event : TableRowEvent ) : void {


    this.viewVehicle(event.row);


  }

  viewVehicle ( vehicle : VehicleModel ) : void {
    this.router.stateService.go('app.vehicle', {
      customer_id: vehicle.customer_id,
      id         : vehicle.id
    });
  }
}
